import HttpUtil from '@/common/HttpUtil'

const members = {
  //新增单位会员信息表
  addUnitMembers (params) {
    let url = process.env.VUE_APP_DOMAIN + "/unitmember";
    return HttpUtil.postFile(url,params);
  },

  //新增个人会员信息表
  addIndividual(params) {
    let url = process.env.VUE_APP_DOMAIN + "/member";
    return HttpUtil.postFile(url,params);
  },

  //上传单位盖章表
  addPDF(params){
    let url = process.env.VUE_APP_DOMAIN + "/uploadPdfById";
    return HttpUtil.postFile(url,params);
  },
  //查询消息列表分页
  getMsgPage(params){
    let url = process.env.VUE_APP_DOMAIN + "/message/getMsgPage";
    return HttpUtil.post(url,params);
  },
  //查询各种消息数量
  getCountsOfTypes(params){
    let url = process.env.VUE_APP_DOMAIN + "/message/getCountsOfTypes";
    return HttpUtil.get(url,params);
  },
  //消息已读
  saveMsgRead(params){
    let url = process.env.VUE_APP_DOMAIN + "/message/saveMsgRead";
    return HttpUtil.post(url,params);
  },
  //消息全部已读
  readAllMsg(params){
    let url = process.env.VUE_APP_DOMAIN + "/message/readAllMsg";
    return HttpUtil.get(url,params);
  },
  //消息删除
  deleteMsgs(params){
    let url = process.env.VUE_APP_DOMAIN + "/message/deleteMsgs";
    return HttpUtil.post(url,params);
  },
  //消息全部删除
  deleteAllMsgs(params){
    let url = process.env.VUE_APP_DOMAIN + "/message/deleteAllMsgs";
    return HttpUtil.get(url,params);
  },
  // 查看个人会员证
  getMemberCardShow(id) {
    let url = process.env.VUE_APP_DOMAIN+'/memberCard?id='+id
    return HttpUtil.get(url, null)
  },
  // 查看单位会员证
  getunitMemberCardShow(id) {
    let url = process.env.VUE_APP_DOMAIN+'/unitMemberCard?id='+id
    return HttpUtil.get(url, null)

  },  
  //下载个人会员证
  downloadMemberCards (params) {
    let postUrl = process.env.VUE_APP_DOMAIN + '/memberCard'
    return HttpUtil.downloadPOST(postUrl, params).then(res => {
      const blob = new Blob([res.data], {
        type: 'application/jpg',
      });
      // let fileName = 'point.xls';
      let headers = res.headers
      let contentType = headers['content-type']
      if ('download' in document.createElement('a')) {
          // 不是IE浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          // link.style.display = 'none';
          link.href = url;
          link.download='会员证.jpg'
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          // 下载完成移除元素
          window.URL.revokeObjectURL(url) // 释放掉blob对象
      } else {
          // IE 10+
          window.navigator.msSaveBlob(blob)
      }
    }).catch(err => {
    })
  },
    //下载单位会员证
    downloadUnitMemberCard (params) {
      let postUrl = process.env.VUE_APP_DOMAIN + '/unitMemberCard'
      return HttpUtil.downloadPOST(postUrl, params).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/jpg',
        });
        // let fileName = 'point.xls';
        let headers = res.headers
        let contentType = headers['content-type']
        if ('download' in document.createElement('a')) {
            // 不是IE浏览器
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            // link.style.display = 'none';
            link.href = url;
            link.download='会员证.jpg'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // 下载完成移除元素
            window.URL.revokeObjectURL(url) // 释放掉blob对象
        } else {
            // IE 10+
            window.navigator.msSaveBlob(blob)
        }
      }).catch(err => {
      })
    },
    // 根据id获取个人会员信息
    getVipPersionById(id) {
    let url = process.env.VUE_APP_DOMAIN+`/getVipPersionById/${id}`
    return HttpUtil.get(url, null)

  },  
  // 根据id获取单位会员信息
  getVipTeamById(id) {
    let url = process.env.VUE_APP_DOMAIN+`/getVipTeamById/${id}`
    return HttpUtil.get(url, null)

  },  
};
export default members
